import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow, SectionHeading } from "@/components/Reveal";

const FAQS = [
  {
    q: "Is VeraChart an EHR?",
    a: "No. We provide prompt libraries that help you write the notes you will eventually paste into your existing EHR.",
  },
  {
    q: "Do I have to pay monthly?",
    a: "No. VeraChart is licensed per team as a one-time license fee — starting at $1,500 per ACT/PACT/FACT team — including implementation and training. There is no monthly subscription.",
  },
  {
    q: "Does this work for facility-based teams?",
    a: "Yes. Our prompts are highly adaptable for both community field workers and facility-based staff.",
  },
  {
    q: "What AI platform do we need?",
    a: "Our prompts work in any major generative AI platform. We will train you on how to use them in the secure platform your agency already approves.",
  },
];

export function Faq() {
  return (
    <section id="faq" className="bg-white py-20 lg:py-28" aria-labelledby="faq-heading">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>FAQ</Eyebrow>
          <SectionHeading id="faq-heading">Questions Executives Ask Us</SectionHeading>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-slate-200">
                <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-navy transition-colors hover:text-teal-700 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
